<template>
    <div>
        <!-- Desktop Embedded Version (your original) -->
        <div class="doc_chat_cls hide-from-mobile">
            <div class="doc_chat_cls_container">
                <div class="doc_chat_cls_header">
                    <img src="img/PriMeds_LogoNEW_White.ae08dac8.png" class="image-406" style="height: 45px;" />
                </div>
                <div class="doc_chat_cls_messages" id="chatMessages">
                    <template v-for="message in messages">
                        <div class="doc_chat_cls_message_container" :key="message.id">

                            <div class="doc_chat_cls_message doc_chat_cls_received" v-if="message.in_out == 0">
                                <!-- Show sender label for incoming messages -->
                                <div class="doc_chat_cls_sender_label">
                                    {{ getSenderLabel(message) }}
                                </div>
                                <div>{{ message.message }}</div>
                                <!-- File attachments for received messages (temporarily disabled)
                                <div v-if="message.attachments && message.attachments.length > 0" class="doc_chat_cls_attachments">
                                    <div v-for="attachment in message.attachments" :key="attachment.id || attachment.url" class="doc_chat_cls_attachment">
                                        <a :href="attachment.url" target="_blank" class="doc_chat_cls_attachment_link">
                                            <span class="doc_chat_cls_attachment_icon">{{ getAttachmentIcon(attachment.type) }}</span>
                                            {{ attachment.name || getAttachmentName(attachment.url, attachment.type) }}
                                        </a>
                                    </div>
                                </div> -->
                            </div>

                            <div class="doc_chat_cls_message doc_chat_cls_sent" v-else>
                                <div>{{ message.message }}</div>
                                <!-- File attachments for sent messages (temporarily disabled)
                                <div v-if="message.attachments && message.attachments.length > 0" class="doc_chat_cls_attachments">
                                    <div v-for="attachment in message.attachments" :key="attachment.id || attachment.url" class="doc_chat_cls_attachment">
                                        <a :href="attachment.url" target="_blank" class="doc_chat_cls_attachment_link">
                                            <span class="doc_chat_cls_attachment_icon">{{ getAttachmentIcon(attachment.type) }}</span>
                                            {{ attachment.name || getAttachmentName(attachment.url, attachment.type) }}
                                        </a>
                                    </div>
                                </div> -->
                            </div>

                            <div class="doc_chat_cls_message_time" :class="message.in_out == 0 ? 'align-left' : 'align-right'">
                                {{ formatLocal(message.created_at) }}
                            </div>
                        </div>
                    </template>
                </div>
                <div class="doc_chat_cls_typing_indicator" id="typingIndicator">
                    <div class="doc_chat_cls_typing_dots">
                        <div class="doc_chat_cls_typing_dot"></div>
                        <div class="doc_chat_cls_typing_dot"></div>
                        <div class="doc_chat_cls_typing_dot"></div>
                    </div>
                </div>

                <!-- File preview section for desktop -->
                <div v-if="selectedFile" class="doc_chat_cls_file_preview">
                    <div class="doc_chat_cls_file_preview_header">
                        <span>Attached File</span>
                        <button @click="clearFile" class="doc_chat_cls_clear_all_btn">Remove</button>
                    </div>
                    <div class="doc_chat_cls_file_list">
                        <div class="doc_chat_cls_file_item">
                            <div class="doc_chat_cls_file_info">
                                <span class="doc_chat_cls_file_icon">{{ getFileIcon(selectedFile.type) }}</span>
                                <div class="doc_chat_cls_file_details">
                                    <div class="doc_chat_cls_file_name">{{ selectedFile.name }}</div>
                                    <div class="doc_chat_cls_file_size">{{ formatFileSize(selectedFile.size) }}</div>
                                </div>
                            </div>
                            <button @click="clearFile" class="doc_chat_cls_remove_file_btn">✕</button>
                        </div>
                    </div>
                </div>

                <div class="doc_chat_cls_input_container">
                    <div class="doc_chat_cls_input_wrapper">
                        <div class="chat-area-div">
                            <div class="form-block-2 w-form">
                                <div class="form-10">
                                    <div class="attachbtn div-block-1754">
                                        <button class="doc_chat_cls_attachment_button" @click="triggerFileInput" title="Attach files" :disabled="isUploading || isSendingMessage">
                                            {{ isUploading ? '⏳' : (selectedFile ? '📄' : '📎') }}
                                        </button>
                                        <input type="file" ref="fileInput" @change="handleFileSelect" accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png,.gif,.mp4,.avi,.mov" style="display: none">
                                    </div>
                                    <textarea maxlength="256" style="resize: none;" name="message" rows="2" placeholder="Type your message..." class="text-field-53 w-input" v-model="messageToSend" spellcheck="false" aria-label="To enrich screen reader interactions, please activate Accessibility in Grammarly extension settings"></textarea>
                                     <div 
                                            class="doc_chat_cls_send_button" 
                                            @click.prevent="SendDocMessage()"
                                            :class="{ 'disabled': !canSendMessage }"
                                        >
                                        <span v-if="isUploading || isSendingMessage"> ⏳ </span>
                                        <span v-else>
                                            <img 
                                                src="@/assets/images/Image_from_iOS.jpg" 
                                                loading="lazy" 
                                                alt="Send" 
                                                class="image-413"
                                            >
                                        </span>
                                            
                                        </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Mobile Popup Version (using your working chat structure) -->
        <transition name="fade-scale">
            <section v-if="showMobilePopup" class="section-6 show-on-mobile">
                <div class="chat-box-div">
                    <div class="abubody">
                        <!-- Header -->
                        <div class="box-top-div">
                            <div class="chat-top-div">
                                <img src="img/PriMeds_LogoNEW_White.ae08dac8.png" class="image-406" style="height: 45px;" />
                                <span class="close-btn" @click.prevent="toggleMobilePopUp()">✕</span>
                            </div>
                            
                            <!-- Chat Messages - using your working structure -->
                            <div class="chat-body-div">
                                <div class="chat-reco-div" ref="chatContainer">
                                    <div class="chat-div">
                                        <div class="dialogue-div" v-for="(message, index) in messages" :key="`message-${index}`">
                                            <!-- User Message -->
                                            <div class="user-div" v-if="message.in_out == 1">
                                                <div class="speech">
                                                    <div class="text-block-806">{{ message.message }}</div>
                                                    <!-- File attachments for sent messages (temporarily disabled)
                                                    <div v-if="message.attachments && message.attachments.length > 0" class="doc_chat_cls_attachments">
                                                        <div v-for="attachment in message.attachments" :key="attachment.id || attachment.url" class="doc_chat_cls_attachment">
                                                            <a :href="attachment.url" target="_blank" class="doc_chat_cls_attachment_link">
                                                                <span class="doc_chat_cls_attachment_icon">{{ getAttachmentIcon(attachment.type) }}</span>
                                                                {{ attachment.name || getAttachmentName(attachment.url, attachment.type) }}
                                                            </a>
                                                        </div>
                                                    </div> -->
                                                    <small v-if="message.created_at" class="message-timestamp">
                                                        {{ formatLocal(message.created_at) }}
                                                    </small>
                                                </div>
                                            </div>
                                            
                                            <!-- Assistant Message -->
                                            <div class="platform-div" v-else>
                                                <div class="div-block-1757"></div>
                                                <div class="response-div">
                                                    <div class="doc_chat_cls_sender_label">
                                                        {{ getSenderLabel(message) }}
                                                    </div>
                                                    <p class="paragraph-132">{{ message.message }}</p>
                                                    <!-- File attachments for received messages (temporarily disabled)
                                                    <div v-if="message.attachments && message.attachments.length > 0" class="doc_chat_cls_attachments">
                                                        <div v-for="attachment in message.attachments" :key="attachment.id || attachment.url" class="doc_chat_cls_attachment">
                                                            <a :href="attachment.url" target="_blank" class="doc_chat_cls_attachment_link">
                                                                <span class="doc_chat_cls_attachment_icon">{{ getAttachmentIcon(attachment.type) }}</span>
                                                                {{ attachment.name || getAttachmentName(attachment.url, attachment.type) }}
                                                            </a>
                                                        </div>
                                                    </div> -->
                                                    <small v-if="message.created_at" class="message-timestamp">
                                                        {{ formatLocal(message.created_at) }}
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- File preview section for mobile -->
                        <div v-if="selectedFile" class="doc_chat_cls_file_preview">
                            <div class="doc_chat_cls_file_preview_header">
                                <span>Attached File</span>
                                <button @click="clearFile" class="doc_chat_cls_clear_all_btn">Remove</button>
                            </div>
                            <div class="doc_chat_cls_file_list">
                                <div class="doc_chat_cls_file_item">
                                    <div class="doc_chat_cls_file_info">
                                        <span class="doc_chat_cls_file_icon">{{ getFileIcon(selectedFile.type) }}</span>
                                        <div class="doc_chat_cls_file_details">
                                            <div class="doc_chat_cls_file_name">{{ selectedFile.name }}</div>
                                            <div class="doc_chat_cls_file_size">{{ formatFileSize(selectedFile.size) }}</div>
                                        </div>
                                    </div>
                                    <button @click="clearFile" class="doc_chat_cls_remove_file_btn">✕</button>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Input Area for mobile -->
                        <div class="box-bottom-div" style="width:100%">
                            <div class="chat-area-div">
                                <div class="form-block-2 w-form">
                                    <div class="form-10">
                                        <div class="attachbtn div-block-1754">
                                            <button class="doc_chat_cls_attachment_button" @click="triggerFileInput" title="Attach files" :disabled="isUploading || isSendingMessage">
                                                {{ isUploading ? '⏳' : (selectedFile ? '📄' : '📎') }}
                                            </button>
                                            <input type="file" ref="fileInputMobile" @change="handleFileSelect" accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png,.gif,.mp4,.avi,.mov" style="display: none">
                                        </div>
                                        <textarea 
                                            maxlength="256" 
                                            style="resize: none;" 
                                            name="message" 
                                            rows="2" 
                                            placeholder="Type your message..." 
                                            class="text-field-53 w-input" 
                                            v-model="messageToSend" 
                                            spellcheck="false"
                                            @keypress.enter.prevent="SendDocMessage()"
                                        ></textarea>
                                        <div 
                                            class="doc_chat_cls_send_button" 
                                            @click.prevent="SendDocMessage()"
                                            :class="{ 'disabled': !canSendMessage }"
                                        >
                                            <span v-if="isUploading || isSendingMessage">⏳</span>
                                            <span v-else>
                                                <img 
                                                    src="@/assets/images/Image_from_iOS.jpg" 
                                                    loading="lazy" 
                                                    alt="Send" 
                                                    class="image-413"
                                                >
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </transition>
    </div>
</template>

<script>
export default {
    props: ["encounterId"],
    components: {},
    data() {
        return {
            baseUrl: `${process.env.VUE_APP_API_ENDPOINT}`,
            loading: true,
            messages: [],
            messageToSend: '',
            selectedFile: null,
            maxFileSize: 5 * 1024 * 1024, // 5MB limit
            isUploading: false,
            isSendingMessage: false,
        }
    },
    mounted() {
        this.getMessages();
        this.setupKeyboardHandling();
    },
    beforeUnmount() {
        this.removeKeyboardHandling();
    },
    computed: {
        canSendMessage() {
            return this.messageToSend.trim().length > 0 || this.selectedFile
        },
        showMobilePopup() {
            return this.$store.getters.docChatStatus
        }
    },
    methods: {
        async toggleMobilePopUp() {
            await this.$store.dispatch('toggeleDocChat');
        },
        
        // Simple keyboard handling from your working chat
        setupKeyboardHandling() {
            if (!/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return;
            }

            if (this.showMobilePopup) {
                document.body.style.overflow = 'hidden';
                document.body.style.position = 'fixed';
                document.body.style.width = '100%';
                document.body.style.height = '100%';
            }
        },

        removeKeyboardHandling() {
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.width = '';
            document.body.style.height = '';
        },

        scrollToBottom() {
            this.$nextTick(() => {
                // For mobile popup
                const chatContainer = this.$refs.chatContainer;
                if (chatContainer) {
                    chatContainer.scrollTop = chatContainer.scrollHeight;
                }
                
                // For desktop embedded
                const messagesContainer = document.getElementById('chatMessages');
                if (messagesContainer) {
                    messagesContainer.scrollTop = messagesContainer.scrollHeight;
                }
            });
        },

        formatLocal(datetime) {
            try {
                const date = new Date(datetime);
                return date.toLocaleString();
            } catch (error) {
                console.log(error)
                return datetime;
            }
        },

        getSenderLabel(message) {
            if (message.in_out === 0 && message.is_doctor === true) {
                return "Doctor";
            }
            return "Support";
        },

        // File handling methods from doc chat
        getAttachmentIcon(fileType) {
            if (!fileType) return '📎';
            if (fileType.startsWith('image/')) return '🖼️';
            if (fileType.startsWith('video/')) return '🎥';
            if (fileType.includes('pdf')) return '📄';
            if (fileType.includes('word') || fileType.includes('document')) return '📝';
            if (fileType.includes('text')) return '📄';
            return '📎';
        },

        getAttachmentName(url, type) {
            if (!url) return 'Attachment';
            const urlParts = url.split('/');
            const filename = urlParts[urlParts.length - 1];
            if (filename && filename.includes('.')) {
                return filename;
            }
            if (type && type.startsWith('image/')) {
                return `Image.${type.split('/')[1]}`;
            }
            if (type && type.startsWith('video/')) {
                return `Video.${type.split('/')[1]}`;
            }
            if (type && type.includes('pdf')) {
                return 'Document.pdf';
            }
            return 'Attachment';
        },

        triggerFileInput() {
            if (this.isUploading) return;

            // Use the appropriate file input based on screen size
            const fileInput = this.showMobilePopup ? this.$refs.fileInputMobile : this.$refs.fileInput;
            if (fileInput) {
                fileInput.click();
            }
        },

        handleFileSelect(event) {
            const file = event.target.files[0];
            if (!file) return;

            if (file.size > this.maxFileSize) {
                alert(`File "${file.name}" is too large. Maximum size is ${this.formatFileSize(this.maxFileSize)}.`);
                return;
            }

            this.selectedFile = file;
            event.target.value = '';
        },

        clearFile() {
            this.selectedFile = null;
        },

        getFileIcon(fileType) {
            if (fileType.startsWith('image/')) return '🖼️';
            if (fileType.startsWith('video/')) return '🎥';
            if (fileType.includes('pdf')) return '📄';
            if (fileType.includes('word') || fileType.includes('document')) return '📝';
            if (fileType.includes('text')) return '📄';
            return '📎';
        },

        formatFileSize(bytes) {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        },

        generateUUID() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                const r = Math.random() * 16 | 0;
                const v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },

        getFileExtension(filename) {
            const parts = filename.split('.');
            return parts.length > 1 ? parts.pop().toLowerCase() : '';
        },

        async getSignedUrl(filename, contentType) {
            try {
                const response = await fetch(`${this.baseUrl}/api/get-signed-url`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        filename,
                        content_type: contentType
                    })
                })

                if (!response.ok) {
                    throw new Error('Failed to get signed URL')
                }

                return await response.json()
            } catch (error) {
                throw new Error('Error getting signed URL: ' + error.message)
            }
        },

        async uploadFileToS3(file) {
            if (!file) return null;

            try {
                this.isUploading = true;

                const fileExtension = this.getFileExtension(file.name);
                const uuid = this.generateUUID();
                const s3Filename = `public/messages/uploads/${uuid}.${fileExtension}`;

                const signedUrlResponse = await this.getSignedUrl(s3Filename, file.type);

                if (!signedUrlResponse.success || !signedUrlResponse.upload_url) {
                    throw new Error('Failed to get upload URL');
                }

                const uploadResponse = await fetch(signedUrlResponse.upload_url, {
                    method: 'PUT',
                    body: file,
                    headers: {
                        'Content-Type': file.type,
                    }
                });

                if (!uploadResponse.ok) {
                    throw new Error(`Failed to upload file to S3: ${uploadResponse.status} ${uploadResponse.statusText}`);
                }

                return {
                    url: signedUrlResponse.public_url || signedUrlResponse.upload_url.split('?')[0],
                    type: file.type,
                    name: file.name
                };

            } catch (error) {
                console.error('File upload failed:', error);
                alert('Failed to upload file. Please try again.');
                return null;
            } finally {
                this.isUploading = false;
            }
        },

        async SendDocMessage() {
            if ((this.messageToSend.trim().length === 0 && !this.selectedFile) || this.isUploading) {
                return;
            }

            let attachmentData = null;

            if (this.selectedFile) {
                attachmentData = await this.uploadFileToS3(this.selectedFile);
                if (this.selectedFile && !attachmentData) {
                    return;
                }
            }

            try {
                const requestData = {
                    message: this.messageToSend || (attachmentData ? '[File attachment]' : ''),
                    latestEncounterId: this.encounterId
                };

                if (attachmentData) {
                    requestData.attachments = [attachmentData];
                }

                const response = await this.$axios.post(`${this.baseUrl}/api/provider-messages`, requestData);

                if (response.data.success) {
                    const newMessage = {
                        id: response.data.apiResponse?.data?.message?.id || Date.now(),
                        message: this.messageToSend || (attachmentData ? '[File attachment]' : ''),
                        in_out: 1,
                        created_at: new Date().toISOString()
                    };

                    if (attachmentData) {
                        newMessage.attachments = [attachmentData];
                    }

                    this.messages.push(newMessage);
                    this.messageToSend = '';
                    this.selectedFile = null;
                    this.scrollToBottom();
                }
            } catch (error) {
                console.error('Message send failed:', error);
                alert('Failed to send message. Please try again.');
            }
        },

        async getMessages() {
            this.loading = true;
            const response = await this.$axios.get(`${this.baseUrl}/api/provider-messages`);
            if (response.data.success) {
                this.messages = response.data.messages;
                if (this.messages.length < 1) {
                    this.messages.push({
                        id: 0,
                        message: "How can I help you today? Feel free to tell me about your symptoms or ask questions.",
                        in_out: 0,
                        created_at: new Date().toISOString()
                    })
                }
                this.loading = false;
                this.scrollToBottom();
            }
        }
    },
    created() {}
}
</script>


<style scoped>
/* =================================================
   RESPONSIVE UTILITY CLASSES
   ================================================= */
.show-on-mobile {
    display: none;
}

.hide-from-mobile {
    display: block;
}

@media (max-width: 768px) {
    .show-on-mobile {
        display: block;
    }

    .hide-from-mobile {
        display: none;
    }
}

/* =================================================
   DESKTOP VERSION STYLES
   ================================================= */

/* Desktop Container */
.doc_chat_cls * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.doc_chat_cls {
    background: white;
    height: 100%;
    margin: 0;
    padding: 0;
}

.doc_chat_cls_container {
    width: 100%;
    height: 573px;
    background: white;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

/* Desktop Header */
.doc_chat_cls_header {
    background: linear-gradient(135deg, #2E9BF4, #2E9BF4);
    color: white;
    padding: 20px;
    text-align: left;
    font-size: 18px;
    font-weight: 600;
}

/* Desktop Messages Area */
.doc_chat_cls_messages {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 15px;
    max-height: calc(100% - 140px);
}

.doc_chat_cls_messages::-webkit-scrollbar {
    width: 6px;
}

.doc_chat_cls_messages::-webkit-scrollbar-track {
    background: transparent;
}

.doc_chat_cls_messages::-webkit-scrollbar-thumb {
    background: rgba(102, 126, 234, 0.3);
    border-radius: 3px;
}

.doc_chat_cls_messages::-webkit-scrollbar-thumb:hover {
    background: rgba(102, 126, 234, 0.5);
}

/* Desktop Message Styling */
.doc_chat_cls_message {
    max-width: 80%;
    padding: 12px 16px;
    border-radius: 18px;
    font-size: 14px;
    line-height: 1.4;
    animation: doc_chat_cls_fadeIn 0.3s ease-out;
}

.doc_chat_cls_message.doc_chat_cls_sent {
    align-self: flex-end;
    background: linear-gradient(135deg, #2E9BF4, #2E9BF4);
    color: white;
    border-bottom-right-radius: 4px;
}

.doc_chat_cls_message.doc_chat_cls_received {
    align-self: flex-start;
    background: #f1f3f5;
    color: #333;
    border-bottom-left-radius: 4px;
}

.doc_chat_cls_message_container {
    display: flex;
    flex-direction: column;
    max-width: 100%;
}

.doc_chat_cls_message_time {
    font-size: 11px;
    opacity: 0.7;
    margin-top: 4px;
}

.align-left {
    align-self: flex-start;
    margin-left: 8px;
}

.align-right {
    align-self: flex-end;
    margin-right: 8px;
}

/* Desktop Input Area */
.doc_chat_cls_input_container {
    padding: 15px;
    background: #2e9bf0 !important;
    border-top: 1px solid #e9ecef;
}

.doc_chat_cls_input_wrapper {
    display: flex;
    gap: 10px;
    align-items: center;
}

.doc_chat_cls_input_wrapper .chat-area-div {
    width: 100%;
    border: 0px;
}

.doc_chat_cls_input_container textarea.w-input,
.doc_chat_cls_input_container textarea.w-select {
    padding: 8px 60px;
}

.doc_chat_cls_attachment_button {
    width: 40px;
    height: 40px;
    border: 2px solid #e9ecef;
    background: white;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    transition: all 0.3s ease;
    flex-shrink: 0;
}

.doc_chat_cls_attachment_button:hover {
    border-color: #2E9BF4;
    background: #f8f9fa;
}

.doc_chat_cls_input_container .doc_chat_cls_attachment_button {
    margin-top: -15px;
}

.attachbtn.div-block-1754 {
    left: 10px;
    top: 25px;
}

.doc_chat_cls_send_button {
    width: 45px;
    height: 45px;
    border: none;
    background: linear-gradient(135deg, #2E9BF4, #2E9BF4);
    color: white;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    font-size: 18px;
}

.doc_chat_cls_send_button:hover {
    transform: scale(1.05);
    box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
}

.doc_chat_cls_send_button:active {
    transform: scale(0.95);
}

.doc_chat_cls_send_button:disabled,
.doc_chat_cls_send_button.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
}

.doc_chat_cls_input_container .doc_chat_cls_send_button {
    position: absolute;
    right: 5px;
    top: 5px;
}

.doc_chat_cls_input_wrapper .image-413 {
    width: 45px;
}

.doc_chat_cls_input_wrapper .chtnote {
    margin-top: 5px;
    margin-bottom: -8px;
}

/* Desktop Typing Indicator */
.doc_chat_cls_typing_indicator {
    display: none;
    align-self: flex-start;
    padding: 12px 16px;
    background: #f1f3f5;
    border-radius: 18px;
    border-bottom-left-radius: 4px;
    max-width: 80px;
}

.doc_chat_cls_typing_dots {
    display: flex;
    gap: 3px;
}

.doc_chat_cls_typing_dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #999;
    animation: doc_chat_cls_typing 1.4s infinite;
}

.doc_chat_cls_typing_dot:nth-child(2) {
    animation-delay: 0.2s;
}

.doc_chat_cls_typing_dot:nth-child(3) {
    animation-delay: 0.4s;
}

/* =================================================
   MOBILE POPUP STYLES (from your working chat)
   ================================================= */

/* Mobile Popup Animations */
.fade-scale-enter-active,
.fade-scale-leave-active {
    transition: all 0.3s ease;
}

.fade-scale-enter,
.fade-scale-leave-to {
    opacity: 0;
    transform: scale(0.95);
}

/* Mobile Popup Container */
.section-6 {
    position: fixed;
    inset: 0%;
    z-index: 9999;
}

.chat-box-div {
    border: 1px solid var(--black);
    background-color: var(--white);
    flex-flow: column;
    justify-content: space-between;
    width: 400px;
    display: flex;
    position: absolute;
    inset: 0% 0% 0% auto;
}

@media (max-width: 768px) {
    .chat-box-div {
        flex-flow: column;
        justify-content: space-between;
        width: 100%;
        display: flex;
        inset: 0%;
    }
}

/* Mobile Header */
.chat-top-div {
    border-bottom: 1px solid var(--black);
    background-color: var(--light-green);
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    display: flex;
}

.image-406 {
    height: 20px;
}

.close-btn {
    cursor: pointer;
    font-size: 18px;
    color: white;
}

/* Mobile Messages Area */
.chat-body-div {
    max-width: 400px;
    padding: 0 10px 0;
    position: relative;
    overflow: visible;
}

@media (max-width: 768px) {
    .chat-body-div {
        max-width: 1000px;
        padding-top: 0;
        overflow: auto;
    }
}

.chat-reco-div {
    height: 530px;
    margin-bottom: 0;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.chat-reco-div::-webkit-scrollbar {
    display: none;
}

@media (max-width: 768px) {
    .chat-reco-div {
        height: 100vh !important;
        padding-bottom: 240px;
    }
}

/* Mobile Message Styling */
.chat-div {
    border: 1px #000;
    margin-bottom: 15px;
}

.dialogue-div {
    padding: 15px 10px 10px 0;
}

.user-div {
    flex-flow: row-reverse;
    width: 100%;
    margin-bottom: 25px;
    display: flex;
}

.speech {
    background-color: var(--f3-grey);
    border-radius: 20px;
    width: 75%;
    padding: 10px 15px;
}

.text-block-806 {
    font-family: var(--mulish);
    font-size: 17px;
    line-height: 21px;
}

.platform-div {
    justify-content: flex-start;
    align-items: flex-start;
    display: flex;
}

.div-block-1757 {

    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 99px;
    width: 25px;
    height: 25px;
    margin-right: 10px;
}

.response-div {
    width: 90%;
}

.paragraph-132 {
    font-family: var(--mulish);
    color: var(--black);
    width: auto;
    font-size: 17px;
    line-height: 21px;
}

/* Mobile Input Area */
.box-bottom-div {
    position: absolute;
    bottom: 0vh;
    background: #fff;
    max-width: 100%;
}

.chat-area-div {
    background-color: var(--light-green);
    border-top: 1px solid #000;
    padding: 10px 10px 0;
    height: 95px;
}

.form-10 {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.show-on-mobile .attachbtn.div-block-1754 {
    left: 10px;
    top: 25px;
    position: absolute;
}

.show-on-mobile .doc_chat_cls_attachment_button {
    width: 40px;
    height: 40px;
    border: 2px solid #e9ecef;
    background: white;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    transition: all 0.3s ease;
    margin-top: -15px;
}

.show-on-mobile textarea.text-field-53.w-input {
    margin-top: 0;
    padding-right: 50px;
    padding-left: 60px;
}

.show-on-mobile .doc_chat_cls_send_button {
    position: absolute;
    right: 5px;
    top: 5px;
    width: 45px;
    height: 45px;
    border: none;
    background: linear-gradient(135deg, #2E9BF4, #2E9BF4);
    color: white;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    font-size: 18px;
}

.show-on-mobile .image-413 {
    width: 40px;
    margin-top: 3px;
}



/* =================================================
   SHARED COMPONENTS (File attachments, etc.)
   ================================================= */

/* Shared Sender Label */
.doc_chat_cls_sender_label {
    font-size: 11px;
    font-weight: 600;
    color: #2E9BF4;
    margin-bottom: 4px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* Shared Message Timestamp */
.message-timestamp {
    font-size: 11px;
    opacity: 0.7;
    margin-top: 4px;
    display: block;
}

/* Shared File Attachment Styles */
.doc_chat_cls_attachments {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.doc_chat_cls_attachment {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 6px 8px;
}

.doc_chat_cls_message.doc_chat_cls_received .doc_chat_cls_attachment {
    background: rgba(0, 0, 0, 0.05);
}

.doc_chat_cls_attachment_link {
    color: inherit;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
}

.doc_chat_cls_attachment_link:hover {
    text-decoration: underline;
}

.doc_chat_cls_attachment_icon {
    font-size: 12px;
}

/* Shared File Preview Styles */
.doc_chat_cls_file_preview {
    background: #f8f9fa;
    border-top: 1px solid #e9ecef;
    max-height: 200px;
    overflow-y: auto;
}

@media (max-width: 768px) {
    .doc_chat_cls_file_preview {
        max-height: 150px;
        flex-shrink: 0;
    }
}

.doc_chat_cls_file_preview_header {
    padding: 12px 20px;
    background: #e9ecef;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    font-weight: 600;
}

@media (max-width: 768px) {
    .doc_chat_cls_file_preview_header {
        padding: 10px 15px;
    }
}

.doc_chat_cls_clear_all_btn {
    background: none;
    border: none;
    color: #dc3545;
    cursor: pointer;
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.doc_chat_cls_clear_all_btn:hover {
    background: rgba(220, 53, 69, 0.1);
}

.doc_chat_cls_file_list {
    padding: 8px 20px;
}

@media (max-width: 768px) {
    .doc_chat_cls_file_list {
        padding: 8px 15px;
    }
}

.doc_chat_cls_file_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #e9ecef;
}

.doc_chat_cls_file_item:last-child {
    border-bottom: none;
}

.doc_chat_cls_file_info {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
}

.doc_chat_cls_file_icon {
    font-size: 16px;
}

.doc_chat_cls_file_details {
    flex: 1;
}

.doc_chat_cls_file_name {
    font-size: 13px;
    font-weight: 500;
    color: #333;
    word-break: break-all;
}

.doc_chat_cls_file_size {
    font-size: 11px;
    color: #6c757d;
}

.doc_chat_cls_remove_file_btn {
    background: none;
    border: none;
    color: #dc3545;
    cursor: pointer;
    font-size: 14px;
    padding: 4px;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;
}

.doc_chat_cls_remove_file_btn:hover {
    background: rgba(220, 53, 69, 0.1);
}

/* =================================================
   ANIMATIONS
   ================================================= */

@keyframes doc_chat_cls_fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes doc_chat_cls_typing {
    0%, 60%, 100% {
        transform: translateY(0);
    }

    30% {
        transform: translateY(-10px);
    }
}

/* =================================================
   RESPONSIVE OVERRIDES
   ================================================= */

@media (max-width: 768px) {
    textarea.text-field-53 {
        font-size: 16px !important;
    }
}
</style>
